var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"expert-tip-icon"},[_c('img',{staticClass:"expert-tip-icon__image",attrs:{"src":_vm.src,"alt":"expert tip icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }